//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { parseDate } from '~/utils/parseDate'

const STORAGE_KEY_PREFIX = 'leaderboardFabDismissed:'
const AUTOPLAY_MS = 5000 // set to 0 to turn automatic sliding off (swipe and dots still work)
const SWIPE_MIN_PX = 30
const LONG_PRESS_MS = 350 // touch: hold this long (without moving) to pick the FAB up
const MOUSE_DRAG_START_PX = 5 // mouse: movement needed before a click becomes a drag
const MIN_BOTTOM = 70 // lowest the FAB can go (keeps it above the bottom nav bar) — adjust to its height
const TOP_MARGIN = 8
const FAB_HEIGHT = 100
const POSITION_KEY = 'leaderboardFabBottom'

export default {
  name: 'PromotionTournamentLeaderboardFab',
  data() {
    return {
      trophyIcon: require('~/assets/icons/tournaments/trophy.png'),
      ready: false,
      dismissedIds: [],
      activeId: null, // tracked by id, not index, so a reorder (e.g. a tournament starting) doesn't jump slides
      customBottom: null, // px from the bottom once the player has moved the FAB; null = default CSS position
      dragging: false
    }
  },
  computed: {
    rootStyle() {
      return this.customBottom != null ? { bottom: this.customBottom + 'px' } : {}
    },
    ...mapGetters('tournaments', ['primary', 'fabSlides']),
    isLoggedIn() {
      return !!this.$store.state.auth && !!this.$store.state.auth.user
    },
    visibleSlides() {
      return this.fabSlides.filter((t) => !this.dismissedIds.includes(t.id))
    },
    activeIndex() {
      const i = this.visibleSlides.findIndex((t) => t.id === this.activeId)
      return i === -1 ? 0 : i
    },
    slideIdsKey() {
      return this.fabSlides.map((t) => t.id).join(',')
    }
  },
  created() {
    this.autoplayTimer = null
    this.swipeStartX = null
    this.swipedAt = 0
    this.longPressTimer = null
    this.pressX = 0
    this.pressY = 0
    this.grabOffset = 0
    this.mouseDown = false
    if (this.isLoggedIn) {
      this.fetchIfNeeded()
    }
  },
  mounted() {
    this.syncDismissed()
    this.loadPosition()
    this.ready = true
    this.startAutoplay()
    window.addEventListener('resize', this.clampToViewport)
  },
  beforeDestroy() {
    this.stopAutoplay()
    clearTimeout(this.longPressTimer)
    this.removeMouseListeners()
    window.removeEventListener('resize', this.clampToViewport)
  },
  watch: {
    // Dismissal is stored per tournament id, so re-check whenever the set of tournaments changes
    slideIdsKey() {
      this.syncDismissed()
    },
    // Slider only needs to run with 2+ slides
    'visibleSlides.length'() {
      this.startAutoplay()
    },
    // Covers logging in mid-session (SPA navigation, no full page reload) rather than
    // only the logged-in-at-mount case handled in created().
    isLoggedIn(loggedIn) {
      if (loggedIn) this.fetchIfNeeded()
    }
  },
  methods: {
    fetchIfNeeded() {
      // The list (active + upcoming) is needed to populate the slides — layouts/default.vue should
      // ideally already dispatch this once; dispatching here too is a safe no-op if so.
      if (!this.primary) {
        this.$store.dispatch('tournaments/fetchList')
      }
      // Guarded against duplicate intervals inside the action itself — safe even with multiple FABs.
      this.$store.dispatch('tournaments/startClock')
    },
    startDateLabel(t) {
      if (!t || !t.startsAt) return ''
      return parseDate(t.startsAt).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })
    },
    syncDismissed() {
      // sessionStorage is client-only — safe here, not in created()/SSR
      this.dismissedIds = this.fabSlides
          .filter((t) => window.sessionStorage.getItem(STORAGE_KEY_PREFIX + t.id) === '1')
          .map((t) => t.id)
    },
    go(index) {
      const len = this.visibleSlides.length
      if (!len) return
      this.activeId = this.visibleSlides[((index % len) + len) % len].id
    },
    startAutoplay() {
      this.stopAutoplay()
      if (!AUTOPLAY_MS || this.visibleSlides.length < 2) return
      // Respect the OS "reduce motion" setting
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
      this.autoplayTimer = setInterval(() => this.go(this.activeIndex + 1), AUTOPLAY_MS)
    },
    stopAutoplay() {
      clearInterval(this.autoplayTimer)
      this.autoplayTimer = null
    },
    // ---- Moving the FAB (vertical only, stays docked to the right edge) ----
    clampBottom(b) {
      const max = Math.max(MIN_BOTTOM, window.innerHeight - FAB_HEIGHT - TOP_MARGIN)
      return Math.min(max, Math.max(MIN_BOTTOM, b))
    },
    loadPosition() {
      try {
        const saved = parseFloat(window.localStorage.getItem(POSITION_KEY))
        if (!isNaN(saved)) this.customBottom = this.clampBottom(saved)
      } catch (e) {
        /* storage unavailable — keep the default position */
      }
    },
    savePosition() {
      try {
        window.localStorage.setItem(POSITION_KEY, String(this.customBottom))
      } catch (e) {
        /* ignore */
      }
    },
    // Keeps a saved position reachable after rotating the phone / resizing the window
    clampToViewport() {
      if (this.customBottom != null) this.customBottom = this.clampBottom(this.customBottom)
    },
    beginDrag(clientY) {
      const rect = this.$el.getBoundingClientRect()
      this.grabOffset = rect.bottom - clientY // keeps the finger/cursor at the same spot on the FAB
      this.dragging = true
      this.stopAutoplay()
    },
    dragTo(clientY) {
      this.customBottom = this.clampBottom(window.innerHeight - (clientY + this.grabOffset))
    },
    endDrag() {
      this.dragging = false
      this.swipedAt = Date.now() // the release must not count as a tap that opens the panel
      this.savePosition()
      this.startAutoplay()
    },
    // Mouse: drag as soon as the cursor moves a few px while pressed (no scroll conflict on desktop)
    onMouseDown(e) {
      if (e.button !== 0 || e.target.closest('.leaderboard-fab__close, .leaderboard-fab__dot')) return
      this.mouseDown = true
      this.pressX = e.clientX
      this.pressY = e.clientY
      window.addEventListener('mousemove', this.onMouseMove)
      window.addEventListener('mouseup', this.onMouseUp)
    },
    onMouseMove(e) {
      if (!this.mouseDown) return
      if (!this.dragging) {
        if (Math.abs(e.clientY - this.pressY) < MOUSE_DRAG_START_PX) return
        this.beginDrag(this.pressY)
      }
      this.dragTo(e.clientY)
    },
    onMouseUp() {
      this.mouseDown = false
      this.removeMouseListeners()
      if (this.dragging) this.endDrag()
    },
    removeMouseListeners() {
      window.removeEventListener('mousemove', this.onMouseMove)
      window.removeEventListener('mouseup', this.onMouseUp)
    },

    onTouchStart(e) {
      const t = e.touches[0]
      this.swipeStartX = t.clientX
      this.pressX = t.clientX
      this.pressY = t.clientY
      this.stopAutoplay()
      // Hold still for a moment to pick the FAB up; moving earlier means it's a swipe/scroll instead
      clearTimeout(this.longPressTimer)
      this.longPressTimer = setTimeout(() => {
        this.beginDrag(this.pressY)
        this.swipeStartX = null // no slide change from this gesture
        if (navigator.vibrate) navigator.vibrate(10)
      }, LONG_PRESS_MS)
    },
    onTouchMove(e) {
      const t = e.touches[0]
      if (this.dragging) {
        e.preventDefault() // stop the page scrolling under the finger
        this.dragTo(t.clientY)
        return
      }
      if (Math.abs(t.clientX - this.pressX) > 8 || Math.abs(t.clientY - this.pressY) > 8) {
        clearTimeout(this.longPressTimer)
      }
    },
    onTouchEnd(e) {
      clearTimeout(this.longPressTimer)
      if (this.dragging) {
        this.endDrag()
        this.swipeStartX = null
        return
      }
      if (this.swipeStartX != null && e.changedTouches && e.changedTouches.length) {
        const dx = e.changedTouches[0].clientX - this.swipeStartX
        if (Math.abs(dx) >= SWIPE_MIN_PX) {
          this.go(this.activeIndex + (dx < 0 ? 1 : -1))
          this.swipedAt = Date.now() // so the tap that ends a swipe doesn't also open the panel
        }
      }
      this.swipeStartX = null
      this.startAutoplay()
    },
    open(t) {
      if (Date.now() - this.swipedAt < 350) return
      this.$emit('open', t.id)
    },
    dismiss() {
      const current = this.visibleSlides[this.activeIndex]
      if (!current) return
      // Move to the neighbouring slide first, then hide this one (only this one — the rest stay)
      const next = this.visibleSlides[(this.activeIndex + 1) % this.visibleSlides.length]
      this.activeId = next.id !== current.id ? next.id : null
      this.dismissedIds = [...this.dismissedIds, current.id]
      window.sessionStorage.setItem(STORAGE_KEY_PREFIX + current.id, '1')
      this.$emit('dismiss', current.id)
    }
  }
}
